import { useEffect, useState } from 'react';

/**
 * Breakpoints based on Readymag prototype analysis
 * - Desktop: >= 1025px (1024px container)
 * - Mobile: <= 1024px (full width responsive)
 */
const MOBILE_BREAKPOINT = 1024;

// Get initial mobile state
const getInitialMobileState = () => {
  if (typeof window === 'undefined') return false;
  return window.innerWidth <= MOBILE_BREAKPOINT;
};

export const useResponsive = () => {
  const [isMobile, setIsMobile] = useState(getInitialMobileState);
  const [windowWidth, setWindowWidth] = useState(
    typeof window !== 'undefined' ? window.innerWidth : 1024
  );

  useEffect(() => {
    // Check if window is defined (for SSR compatibility)
    if (typeof window === 'undefined') return;

    const mediaQuery = window.matchMedia(`(max-width: ${MOBILE_BREAKPOINT}px)`);

    // Set initial state
    setIsMobile(mediaQuery.matches);
    setWindowWidth(window.innerWidth);

    // Handler for media query changes
    const handleMediaChange = (e: MediaQueryListEvent) => {
      setIsMobile(e.matches);
    };

    // Handler for window resize
    const handleResize = () => {
      setWindowWidth(window.innerWidth);
      setIsMobile(window.innerWidth <= MOBILE_BREAKPOINT);
    };

    // Add event listeners
    mediaQuery.addEventListener('change', handleMediaChange);
    window.addEventListener('resize', handleResize);

    // Cleanup
    return () => {
      mediaQuery.removeEventListener('change', handleMediaChange);
      window.removeEventListener('resize', handleResize);
    };
  }, []);

  return {
    isMobile,
    isDesktop: !isMobile,
    windowWidth,
    breakpoint: MOBILE_BREAKPOINT,
  };
};
